var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatternStudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1368_1268)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.79498 4.94509V9.08047H10.9488V4.94509H8.79498ZM8.436 4.25586H11.3078C11.403 4.25586 11.4943 4.29217 11.5616 4.35679C11.6289 4.42142 11.6668 4.50908 11.6668 4.60047V9.42509C11.6668 9.51649 11.6289 9.60414 11.5616 9.66877C11.4943 9.7334 11.403 9.7697 11.3078 9.7697H8.436C8.34079 9.7697 8.24949 9.7334 8.18217 9.66877C8.11485 9.60414 8.07703 9.51649 8.07703 9.42509V4.60047C8.07703 4.50908 8.11485 4.42142 8.18217 4.35679C8.24949 4.29217 8.34079 4.25586 8.436 4.25586Z",
  fill: "currentColor",
  fillOpacity: 0.65,
  stroke: "currentColor",
  strokeOpacity: 0.65,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.51294 2.54721C9.51294 2.34895 9.67366 2.18823 9.87191 2.18823C10.0702 2.18823 10.2309 2.34895 10.2309 2.54721V4.60054H9.51294V2.54721ZM9.51294 9.42516H10.2309V11.4785C10.2309 11.6767 10.0702 11.8375 9.87191 11.8375C9.67366 11.8375 9.51294 11.6767 9.51294 11.4785V9.42516Z",
  fill: "currentColor",
  fillOpacity: 0.65,
  stroke: "currentColor",
  strokeOpacity: 0.65,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.05132 2.87746V11.1482H5.20517V2.87746H3.05132ZM2.69235 2.18823H5.56414C5.65935 2.18823 5.75066 2.22454 5.81798 2.28917C5.8853 2.3538 5.92312 2.44145 5.92312 2.53285V11.4928C5.92312 11.5842 5.8853 11.6719 5.81798 11.7365C5.75066 11.8012 5.65935 11.8375 5.56414 11.8375H2.69235C2.59714 11.8375 2.50584 11.8012 2.43851 11.7365C2.37119 11.6719 2.33337 11.5842 2.33337 11.4928V2.53285C2.33337 2.44145 2.37119 2.3538 2.43851 2.28917C2.50584 2.22454 2.59714 2.18823 2.69235 2.18823Z",
  fill: "currentColor",
  fillOpacity: 0.65,
  stroke: "currentColor",
  strokeOpacity: 0.65,
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.76917 0.359009C3.76917 0.160752 3.92988 3.3851e-05 4.12814 3.3851e-05C4.3264 3.3851e-05 4.48711 0.160752 4.48711 0.359008V2.53296H3.76917V0.359009ZM3.76917 11.5963H4.48711V13.7703C4.48711 13.9685 4.3264 14.1292 4.12814 14.1292C3.92988 14.1292 3.76917 13.9685 3.76917 13.7703V11.5963Z",
  fill: "currentColor",
  fillOpacity: 0.65,
  stroke: "currentColor",
  strokeOpacity: 0.65,
  strokeWidth: 0.2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1368_1268"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "currentColor"
})))));
export default SvgPatternStudio;